import { MapPin, Phone } from "lucide-react";
import { Reveal } from "./Reveal";
import { OpenBadge, WeeklyHours } from "./OpenHours";
import { useLang } from "../../lib/lang";
import { INFO } from "../../lib/content";

export const HoursSection = () => {
  const { lang } = useLang();
  const sv = lang === "sv";
  return (
    <section id="hours" data-testid="hours-section" className="bg-transparent px-5 pt-24 lg:px-10 lg:pt-32">
      <Reveal className="relative mx-auto grid max-w-[1400px] overflow-hidden rounded-[32px] bg-[#1D5E5C] text-white lg:grid-cols-12">
        <div className="pattern-overlay pointer-events-none absolute inset-0 opacity-[0.08]" />
        <div className="relative p-8 sm:p-12 lg:col-span-7">
          <p className="eyebrow text-[#E9C46A]">{sv ? "Besök oss" : "Visit us"}</p>
          <h2 className="font-display mt-4 text-4xl leading-[0.95] tracking-tight sm:text-5xl lg:text-6xl">
            {sv ? "Välkommen in," : "Come on in,"} <em className="italic text-[#E9C46A]">{sv ? "sex dagar i veckan" : "six days a week"}</em>
          </h2>
          <div className="mt-6"><OpenBadge light /></div>
          <div className="mt-10 flex flex-wrap gap-3">
            <a data-testid="hours-call-button" href={INFO.phoneHref} className="btn-gold"><Phone size={16} /> {INFO.phone}</a>
            <a data-testid="hours-directions-link" href={INFO.mapsUrl} target="_blank" rel="noreferrer" className="btn-ghost-light"><MapPin size={16} /> {INFO.address}</a>
          </div>
        </div>
        <div className="relative border-t border-white/15 p-8 sm:p-12 lg:col-span-5 lg:border-l lg:border-t-0">
          <WeeklyHours light />
        </div>
      </Reveal>
    </section>
  );
};
